/* eslint-disable no-console */
import moment from '@tableau/metrics-engine/node_modules/moment';

import { Status } from '../serverAPI/types/CustomDomainTypes';

const certPemRegex = /^(-----BEGIN [A-Z ]+-----\r?\n([a-zA-Z0-9+/=]+\r?\n)+-----END [A-Z ]+-----\r?\n?){2,}$/;
const keyPemRegex = /^(-----BEGIN [A-Z ]+-----\r?\n([a-zA-Z0-9+/=]+\r?\n)+-----END [A-Z ]+-----\r?\n?)+$/;

/*returns the number of hours left for the domain to expire */
export function hoursLeftToExpire(date: Date) {
    //Time to expire in hours
    const timeToExpire = 24;

    let hoursBetweenCurrDate =  moment().diff(date, 'hours');
    return timeToExpire - hoursBetweenCurrDate;
}

export function isValidDomain(v: string) {
    if (!v) return;
    var re = /^(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.){2,}[A-Za-z]{2,6}$/;
    return re.test(v);
}

export function isCnameVerified(v: string) {
    return v === Status.cnameVerificationSuccess ||  v === Status.sslCertUploaded || v === Status.customDomainProvisioned;
}

//Display the first 30 characters inroder to prevent cluttering the UI with large file names.
export function formatFileName(selectedFile: File): string {
    return selectedFile.name.length > 30 ? selectedFile.name.substring(0, 32) + '...' : selectedFile.name;
}

export const isCertPemFormat = async (file: File): Promise<boolean> => {
  const fileContent = await readFileContent(file);
  return certPemRegex.test(fileContent);
};

export const isKeyPemFormat = async (file: File): Promise<boolean> => {
  const fileContent = await readFileContent(file);
  return keyPemRegex.test(fileContent);
};

export async function readFileContent(certificate: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsText(certificate,'UTF-8');

      reader.onload = function() {
        const fileContents = reader.result as string;
        resolve(fileContents);
      };

      reader.onerror = function() {
        reject(new Error('File could not be read.'));
      };
    });
}